/* ABC: живые подсказки в строке поиска, как на abcclothes.ru.

   Замеры их выпадающего списка (страница 1024px):
     панель  — от края 20px, padding 10px, без фона, рамки и тени, z 999999
     список  — одна колонка, gap 20px, до 9 позиций
     строка  — flex, gap 10px, высота 42
     миниатюра — 32x42
     название — 14px / 18.2px / 600 / #000 / uppercase, отступ снизу 5px
     вторая строка — 14px / 18.2px / 400 / rgba(0,0,0,.5) / uppercase

   У них вторая строка — русское имя товара. У нас магазин только
   английский, поэтому туда идёт категория товара (поле type из
   suggest.json) — тот же смысл, что в подписи карточки каталога. */
(function () {
  var LIMIT = 10;   /* максимум, который отдаёт suggest.json */
  var DEBOUNCE = 250;

  var panel, list, input, timer = null, seq = 0;

  function els() {
    panel = document.querySelector('[data-abc-suggest]');
    list = document.querySelector('[data-abc-suggest-list]');
    input = document.querySelector('.abc-search__input');
    return panel && list && input;
  }

  function hide() {
    if (panel) panel.hidden = true;
    if (list) list.innerHTML = '';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* картинки Shopify масштабируем параметром width — 32px по CSS,
     берём 96 под плотные экраны */
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=96';
  }

  function money(v) {
    var n = Number(v);
    if (!isFinite(n)) return '';
    /* ABC 29.09: формат магазина в валюте покупателя + знак CA$/A$/HK$/S$/AED — assets/abc-money.js */
    if (window.abcMoney) return window.abcMoney.format(Math.round(n * 100));
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function isDesktop() { return matchMedia('(min-width: 750px)').matches; }

  /* ПК (владелец, 22.09): под строкой поиска — один ряд миниатюр, как ряд
     цветов в карточке товара (фото 90×120, название, цена); если товаров
     больше, чем влезает, ряд листается вправо (колесо мыши тоже листает вбок).
     Enter ведёт на полную страницу результатов. Телефон — прежний список. */
  /* совпадение в НАЗВАНИИ — выше: поиск Shopify смотрит и в описания, и на
     «long» первыми шли бомберы. Порядок внутри групп — как у Shopify. */
  function byTitle(products, q) {
    var words = String(q || '').toLowerCase().split(/\s+/).filter(Boolean);
    function score(p) {
      var t = String(p.title || '').toLowerCase();
      if (!words.length) return 0;
      var all = words.every(function (w) { return t.indexOf(w) !== -1; });
      return all ? 2 : (words.some(function (w) { return t.indexOf(w) !== -1; }) ? 1 : 0);
    }
    return products.map(function (p, i) { return { p: p, i: i, s: score(p) }; })
      .sort(function (x, y) { return y.s - x.s || x.i - y.i; })
      .map(function (x) { return x.p; });
  }

  /* ПК (владелец, 22.09): панель на всю ширину, карточки — как в каталоге, только
     мельче: предметка 3:4, название, серым «WOMEN · 7 COLORS», цена
     (со скидкой — старая серым и −%). Без стрелок (на сайте их нигде нет):
     ряд листается тачпадом/колесом, под ним тонкая линия прокрутки.
     Внизу — кнопка VIEW ALL (N). Телефон — прежний список. */
  function render(products, q, total) {
    if (!products.length) { hide(); return; }
    var desk = isDesktop();
    panel.classList.toggle('abc-suggest--grid', desk);
    var items = byTitle(products, q);
    list.innerHTML = items.map(function (p) {
      if (desk) {
        var price = p.price_cents != null ? p.price_cents / 100 : Number(p.price);
        var was = p.compare_cents != null ? p.compare_cents / 100 : Number(p.compare_at_price_max);
        var sale = was > price;
        var meta = [p.gender, p.colors].filter(Boolean).map(esc).join(' &middot; ');
        return '<a class="abc-suggest__card" href="' + esc(p.url) + '">' +
          '<span class="abc-suggest__media">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') +
          '</span>' +
          '<span class="abc-suggest__title">' + esc(p.title) + '</span>' +
          (meta ? '<span class="abc-suggest__meta2">' + meta + '</span>' : '') +
          '<span class="abc-suggest__price">' + esc(money(price)) +
            (sale ? '<s>' + esc(money(was)) + '</s><em>\u2212' + Math.round((1 - price / was) * 100) + '%</em>' : '') +
          '</span>' +
        '</a>';
      }
      return '<a class="abc-suggest__item" href="' + esc(p.url) + '">' +
        (p.image ? '<img class="abc-suggest__img" src="' + esc(thumb(p.image)) +
                   '" alt="" width="32" height="42" loading="lazy">'
                 : '<span class="abc-suggest__img"></span>') +
        '<span class="abc-suggest__text">' +
          '<span class="abc-suggest__title">' + esc(p.title) + '</span>' +
          (p.type ? '<span class="abc-suggest__meta">' + esc(p.type) + '</span>' : '') +
        '</span>' +
      '</a>';
    }).join('');
    var foot = panel.querySelector('.abc-suggest__foot');
    if (desk && !foot) {
      foot = document.createElement('div');
      foot.className = 'abc-suggest__foot';
      foot.innerHTML = '<span class="abc-suggest__track"><i></i></span><a class="abc-suggest__all-btn" href="#"></a>';
      panel.appendChild(foot);
      list.addEventListener('scroll', track, { passive: true });
    }
    if (foot) {
      foot.hidden = !desk;
      var a = foot.querySelector('.abc-suggest__all-btn');
      a.href = '/search?type=product&q=' + encodeURIComponent(q || input.value.trim());
      a.textContent = 'View all (' + Math.max(total || 0, items.length) + ')';
    }
    place();
    panel.hidden = false;
    list.scrollLeft = 0;
    track();
  }

  /* тонкая линия прокрутки под рядом: видна, только если ряд длиннее экрана */
  function track() {
    var t = panel.querySelector('.abc-suggest__track');
    if (!t) return;
    var fits = list.scrollWidth <= list.clientWidth + 2;
    t.style.visibility = fits ? 'hidden' : 'visible';
    if (fits) return;
    var part = list.clientWidth / list.scrollWidth;
    var bar = t.firstChild;
    bar.style.width = (part * 100) + '%';
    bar.style.transform = 'translateX(' + (list.scrollLeft / list.clientWidth * 100) + '%)';
  }

  /* ПК: панель на всю ширину страницы (владелец, 22.09) — от края до края под шапкой */
  function place() {
    panel.style.left = panel.style.width = panel.style.right = '';
  }
  addEventListener('resize', function () { if (panel && !panel.hidden) place(); });
  /* колесо мыши над рядом листает его вбок */
  document.addEventListener('wheel', function (e) {
    var row = e.target.closest && e.target.closest('.abc-suggest--grid .abc-suggest__list');
    if (!row || row.scrollWidth <= row.clientWidth || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    e.preventDefault();
    row.scrollLeft += e.deltaY;
  }, { passive: false });

  /* источник — наш шаблон поиска (templates/search.abcjson.liquid): до 30 товаров
     и общее число найденного; если вдруг не ответил — подсказки Shopify (до 10) */
  function lookup(q) {
    var mine = ++seq;
    var url = '/search?type=product&options%5Bprefix%5D=last&view=abcjson&q=' + encodeURIComponent(q);
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (t) {
        var d = JSON.parse(t);
        if (mine !== seq) return;
        render(d.products || [], q, d.count || 0);
      })
      .catch(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + LIMIT, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d || mine !== seq) return;
            render((d.resources && d.resources.results && d.resources.results.products) || [], q, 0);
          })
          .catch(function () {});
      });
  }

  function onInput() {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { hide(); return; }
    timer = setTimeout(function () { lookup(q); }, DEBOUNCE);
  }

  function init() {
    if (!els()) return;
    // ВАЖНО: флаг не называть abcSuggest — он даст на инпуте атрибут
    // data-abc-suggest, и селектор панели начнёт цеплять инпут.
    if (input.dataset.abcSuggestBound) return;
    input.dataset.abcSuggestBound = '1';
    input.addEventListener('input', onInput);
    input.addEventListener('search', onInput);   // крестик очистки в type=search
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });

  /* панель закрывается вместе со строкой поиска */
  document.addEventListener('pointerdown', function (e) {
    if (!panel || panel.hidden) return;
    if (e.target.closest && (e.target.closest('[data-abc-suggest]') ||
        e.target.closest('.abc-search') || e.target.closest('search-button'))) return;
    hide();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hide();
  });
})();
